module.exports = __webpack_public_path__ + "static/media/right-menu-wallet-icon.1473de0c.svg";